<app-header [progress]="2" [title]="locale.currentTranslation.accidentDescriptionHeader" data-testid="incident-description-header"></app-header>
<div class="base-content-container" data-testid="incident-description-container">
  <div class="headline3" data-testid="incident-description-title">{{ locale.currentTranslation.incidentDescription1 }}
  </div>
  <div style="display: flex; flex-direction: column; gap: 24px;" data-testid="options-container">
    @if (isMultipleOptions()) {
      <form [formGroup]="multipleOptionsForm" data-testid="checkbox-form">
        <div formArrayName="selectedOptions" data-testid="checkbox-options">
          @for (option of options; track option;) {
            <label class="radio-button-base" style="margin-top: 16px" [attr.data-testid]="'checkbox-option-' + option.value">
              <div>
                <input type="checkbox"
                       [value]="option.value"
                       [checked]="isSelected(option.value)"
                       (change)="selectCheckbox($event)"
                       [attr.data-testid]="'checkbox-input-' + option.value"
                       [attr.aria-label]="option.headline"
                >
              </div>
              <div>
                <div class="label1" [attr.data-testid]="'checkbox-headline-' + option.value">{{ option.headline }}</div>
                <div class="caption1" [attr.data-testid]="'checkbox-caption-' + option.value">{{ option.caption }}</div>
              </div>
            </label>
          }
        </div>
      </form>
    } @else {
      @for (option of options; track option) {
        <div class="radio-button-base" [attr.data-testid]="'radio-option-' + option.value">
          <div>
            <input type="radio"
              [value]="option.value"
              [formControl]="radioControl"
              [attr.data-testid]="'radio-input-' + option.value"
              [attr.aria-labelledby]="'radio-label-' + option.value">
          </div>
          <div (click)="setOption(option.value)" [attr.data-testid]="'radio-label-container-' + option.value">
            <div class="label1" [attr.id]="'radio-label-' + option.value" [attr.data-testid]="'radio-headline-' + option.value">{{ option.headline}}</div>
            <div class="caption1" [attr.data-testid]="'radio-caption-' + option.value">{{ option.caption }}</div>
          </div>
        </div>
    }
    }
  </div>
  @if (showError) {
    <div class="caption1 error-text" data-testid="validation-error" role="alert">
      {{ locale.currentTranslation.errorMessageUserInputNotChosen }}
    </div>
  }
</div>
<div class="main-button-spacing">
  <button class="main-button" (click)="nextClicked()" data-testid="btn-next" role="button" tabindex="0">{{ locale.currentTranslation.next }}</button>
</div>
<app-footer data-testid="incident-description-footer"></app-footer>
